module.exports = __webpack_public_path__ + "fce8aae43a3f46b8ad03876936b5e6e6.png";